import { clsx, type ClassValue } from "clsx";

/** Tiny helper to join conditional Tailwind class names. `cn("a", cond && "b")` */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
